<template>
  <router-view />
</template>

<script>
import templateModule from '../../store/templates'

export default {
  beforeCreate () {
    this.$store.registerModule('templates', templateModule)
  },
  destroyed () {
    this.$store.unregisterModule('templates')
  }
}
</script>
